export function getQueryParams() {
  const queryString = window.location.search.slice(1);
  if (!queryString) {
    return {};
  }
  return queryString.split('&').reduce((map, pairString) => {
    var _pairArray$;
    const pairArray = pairString.split('=');
    map[pairArray[0]] = decodeURIComponent((_pairArray$ = pairArray[1]) !== null && _pairArray$ !== void 0 ? _pairArray$ : '');
    return map;
  }, {});
}
export function getReferrer() {
  const queryParams = getQueryParams();
  return queryParams.referrer;
}